import React, { useState } from 'react';
import { forgotPassword } from '../api/userApi';
import imageSchool from '../Images/Photo1.PNG';
import { useNavigate } from 'react-router-dom';

const ForgotPassword = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setMessage('');
    setError('');

    try {
      const response = await forgotPassword(email);

      // backend renvoie une STRING
      setMessage(
        response.data || "Email envoyé avec succès. Vérifiez votre boîte mail."
      );

      setEmail('');

    } catch (error) {
      setError(
        typeof error.response?.data === "string"
          ? error.response.data
          : error.response?.data?.message ||
            "Erreur lors de l'envoi du lien."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-page">
      <div className="forgot-shell">
        <div className="forgot-brand-panel">
          <div className="brand-badge">AL-BAWSALA</div>

          <img
            className="brand-image"
            src={imageSchool}
            alt="Illustration de réinitialisation"
          />

          <h1>Réinitialisation du mot de passe</h1>

          <p>
            Récupérez facilement votre accès en recevant un lien de réinitialisation sécurisé
            à votre adresse email professionnelle.
          </p>

          <div className="trust-chip">Sécurité • Confidentialité • Rapidité</div>
        </div>

        <div className="forgot-form-panel">
          <div className="auth-card forgot-card">
            <div className="auth-card-header">
              <span className="header-kicker">Mot de passe oublié</span>
              <h2>Récupération</h2>
            </div>

            <div className="auth-card-body">
              <h3>Réinitialisez votre accès</h3>
              <p>
                Entrez votre adresse email pour recevoir un lien de réinitialisation.
              </p>

              {message && (
                <div className="status-alert success">
                  {message}
                </div>
              )}

              {error && (
                <div className="status-alert error">
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit} className="login-form">
                <div className="form-floating auth-field">
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    placeholder="name@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <label htmlFor="email">Email</label>
                </div>

                <button
                  className="btn btn-primary login-button"
                  type="submit"
                  disabled={loading || !email}
                >
                  {loading ? "Envoi en cours..." : "Envoyer le lien"}
                </button>
              </form>
            </div>

            <div className="auth-card-footer">
              <button
                className="btn btn-link signup-link"
                onClick={() => navigate('/login')}
              >
                Retour à la connexion
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;